<p-table
    *ngIf="content?.cols"
    #dt
    [class]="tableClass"
    [style]="{ width: '100%' }"
    [tableStyle]="{ 'min-width': '100%' }"
    [columns]="content.cols"
    [value]="content.data"
    [rows]="rows ? rows : ($userPrefsNumberOfRows | async)!"
    [loading]="isLoading"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="globalVar.defaultTableRowsPerPageOptions"
    [styleClass]="'p-datatable-striped sera-table' + (isSelection ? ' sera-table-selectable' : '')"
    [paginator]="paginator"
    [resizableColumns]="resizableColumns"
    currentPageReportTemplate="{{ 'PAGE.UIGRID.SHOW.TXT' | translate }} {first} {{ 'PAGE.UIGRID.TO.TXT' | translate }} {last} {{
        'PAGE.UIGRID.OF.TXT' | translate
    }} {totalRecords} {{ 'PAGE.UIGRID.ENTRIES.TXT' | translate }}"
    [globalFilterFields]="filterKeys"
    [lazy]="isLazy"
    columnResizeMode="expand"
    [totalRecords]="isLazy ? totalRecords : content?.data?.length ?? 0"
    (onLazyLoad)="onlazyLoad($event)"
    (onRowReorder)="onRowDrag($event)"
    (sortFunction)="customSort ? sortFunction($event) : undefined"
    (onSort)="rowsSorted.emit($event)"
    [customSort]="customSort"
    [dataKey]="content.dataKey!"
    [(selection)]="selectedRows"
    (selectionChange)="onSelectionChange($event)"
    [selectAll]="selectAll !== undefined ? selectAll : null"
    (selectAllChange)="onSelectAllChange($event)"
    [paginatorDropdownAppendTo]="'body'"
    [rowGroupMode]="groupRows ? 'rowspan' : undefined"
    [groupRowsBy]="groupRows ? groupRowsByField : undefined"
    [scrollable]="scrollable"
    [scrollHeight]="scrollable ? scrollHeight : undefined">
    <ng-template
        #caption
        *ngIf="header">
        <div class="sera-table-header-wrapper">
            <ng-container [ngSwitch]="titleSize">
                <div [class]="onlyTitleHeader ? 'sera-table-header-wrapper-left--only-title' : 'sera-table-header-wrapper-left'">
                    <h2 *ngSwitchCase="'h2'">
                        {{ tableTitle ?? content.tableTitle | translate }}
                        @if (content.tableTitleSubTitle) {
                        <p class="text-paragraph">({{ content.tableTitleSubTitle | translate }})</p>
                        }
                    </h2>
                    <h5 *ngSwitchDefault>{{ tableTitle ?? content.tableTitle | translate }}</h5>
                </div>
                <div class="sera-table-header-wrapper-message">
                    @if(!!infoMessage) {
                    <ds-message
                        [tone]="'neutral'"
                        [variant]="'slim'"
                        [messageText]="infoMessage"></ds-message>
                    }
                </div>
            </ng-container>
            <div
                *ngIf="showToolbarButtons && !hasSearchOption"
                class="sera-table-header-toolbar-horizontal-button-wrapper">
                <div *ngFor="let button of content.toolbarButtons! | filterButtonBasedOnDisplayMode : isEditMode">
                    <ds-button
                        ds-loading
                        [disabled]="(button.isDisabled ? button.isDisabled(null) : false) || disableAllTableActions"
                        [isLoading]="(button.isLoading | async)!"
                        [routerLink]="button.routeTo"
                        (click)="button.action(button)"
                        tooltipPosition="top"
                        [variant]="button.variant ?? 'primary'"
                        [icon]="button.defaultIconClass!"
                        size="md"
                        [ds-tooltip]="button.tooltipText ? (button.tooltipText() | translate) : ''"
                        [dsTooltipConfig]="{ disabled: button.hideTooltip ? button.hideTooltip() : false }">
                        <span *ngIf="button.label && button.label !== ''">{{ button.label! | translate }}</span>
                    </ds-button>
                </div>
            </div>
            <div
                *ngIf="!onlyTitleHeader && hasSearchOption"
                class="sera-table-header-wrapper-right">
                <sera-input-text
                    [placeholder]="searchPlaceHolder | translate"
                    [icon]="'ci ci-search'"
                    [iconSide]="'left'"
                    (inputChanged)="dt.filterGlobal($event, 'contains'); onSearch()"
                    [style]="{ width: '276px' }">
                </sera-input-text>
                <ng-container *ngIf="showToolbarButtons">
                    <div
                        *ngFor="let button of content.toolbarButtons! | filterButtonBasedOnDisplayMode : isEditMode"
                        class="sera-table-toolbar-icon-button-wrapper">
                        <ds-button
                            [disabled]="disableAllTableActions"
                            [routerLink]="button.routeTo"
                            (click)="button.action(button)"
                            tooltipPosition="top"
                            [variant]="button.variant ?? 'primary'"
                            [icon]="button.defaultIconClass!"
                            size="md">
                            <span *ngIf="button.label && button.label !== ''">{{ button.label! | translate }}</span>
                        </ds-button>
                    </div>
                </ng-container>
                <div
                    *ngFor="let tab of content.tabHolderButtons!"
                    class="sera-table-toolbar-tab-holder-wrapper">
                    <sera-tab-holder
                        [isTabHolderButtons]="true"
                        [items]="tab.items"
                        [activeItem]="tab.selectedItem"
                        (changeOfActiveItem)="tab.action($event)">
                    </sera-tab-holder>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template
        #header
        let-columns>
        <tr>
            <th
                *ngIf="isSelection"
                pResizableColumn
                class="sera-selection-cell"
                pFrozenColumn
                [frozen]="frozenSelection"
                alignFrozen="left">
                <div class="sera-selection-cell">
                    <p-tableHeaderCheckbox *ngIf="isSelectAll"></p-tableHeaderCheckbox>
                </div>
            </th>
            <th
                *ngIf="groupRows"
                class="section-header"
                pResizableColumn></th>
            <th
                pResizableColumn
                *ngFor="let col of columns"
                [style.width.px]="col.width"
                [style.max-width.px]="col.maxWidth ?? col.width"
                [pSortableColumn]="col.customSort ? col.customSort : col.field"
                [colSpan]="col.colSpan"
                [pSortableColumnDisabled]="col.disableSort"
                pFrozenColumn
                [frozen]="col.frozen"
                [alignFrozen]="col.alignFrozen || 'left'">
                <div class="header-container">
                    <div [ngClass]="{ header_with_ellipsis: ellipsisOnHeader }">
                        <span
                            class="header-container--label"
                            [title]="col.header | translate">
                            {{ col.header | translate }}
                        </span>
                    </div>
                    <div style="flex-shrink: 0">
                        <svg
                            *ngIf="!col.disableSort"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12 7L16 11H8L12 7Z"
                                fill="#353A41"
                                fill-opacity="0.1" />
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12 17L8 13H16L12 17Z"
                                fill="#353A41"
                                fill-opacity="0.1" />
                        </svg>
                        <sera-icon
                            *ngIf="col.headerIcon"
                            [class]="col.headerIcon.class"
                            [tooltipKey]="col.headerIcon.tooltipKey"></sera-icon>
                    </div>
                </div>
            </th>
            <th
                *ngIf="dragAndDropEnabled"
                pResizableColumn
                [style.width.px]="20"
                [style.max-width.px]="20"></th>
        </tr>
    </ng-template>
    <ng-template
        #body
        let-rowData
        let-rowIndex="rowIndex"
        let-columns="columns"
        let-rowgroup="rowgroup"
        let-rowspan="rowspan">
        <tr
            [style.height.px]="rowHeight"
            [ngClass]="[
                rowClassFn ? rowClassFn(rowData) : '',
                groupRows ? 'row-group-tr' : '',
                !rowspan && groupRows ? 'last-row' : '',
                isSelection && isRowSelected(rowData) ? 'sera-table-row-selected' : ''
            ]"
            [pReorderableRow]="rowIndex">
            <td
                *ngIf="isSelection"
                pFrozenColumn
                [frozen]="frozenSelection"
                alignFrozen="left">
                <div class="sera-selection-cell">
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                </div>
            </td>
            <td
                [class]="'section-td'"
                [attr.rowspan]="rowspan"
                *ngIf="rowgroup">
                <span class="section-label">{{ rowData[groupRowsByField!] }}</span>
            </td>
            <td
                [style.width.px]="col.width"
                [style.max-width.px]="col.maxWidth ?? col.width"
                [ngClass]="col.tdClass"
                *ngFor="let col of columns"
                pFrozenColumn
                [frozen]="col.frozen"
                [alignFrozen]="col.alignFrozen || 'left'">
                <div [ngClass]="col.class">
                    <ng-container [ngSwitch]="col.type">
                        <div *ngSwitchCase="'icon'">
                            <sera-icon
                                *ngIf="rowData[col.conditionalProperty]"
                                [class]="col.class"></sera-icon>
                        </div>
                        <div *ngSwitchCase="'textAndIcons'">
                            <div [ngClass]="col.styleCell">
                                <div [ngClass]="col.styleTextCell">
                                    <span [title]="rowData[col.field]">{{ rowData[col.field] }}</span>
                                </div>
                                <div class="button-col">
                                    <div *ngFor="let button of col.seraButtons | filterButtonBasedOnDisplayMode : isEditMode : rowData">
                                        <ds-button
                                            *ngIf="button.showButton ? button.showButton(rowData) : true"
                                            [disabled]="getIconDisabled(rowData, button) || col.isDisabled"
                                            (click)="button.action(rowData)"
                                            [pTooltip]="rowData[col.field + 'TooltipText'] ?? button.label! | translate"
                                            tooltipPosition="top"
                                            [class]="button.buttonClass!"
                                            [variant]="button.variant ?? 'ghost'"
                                            [icon]="getIconClass(rowData, button)"
                                            size="sm"></ds-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngSwitchCase="'input'">
                            <sera-input-text
                                *ngIf="!col.isDisabled"
                                [style]="{ height: '30px' }"
                                (inputBlur)="handleInputNumberBlur(rowData, col.seraTableAction, $event)"
                                [ngModel]="rowData[col.seraTableAction.value]"
                                (ngModelChange)="updateRowDataValue(rowData, col.seraTableAction, $event)"
                                [isDisabled]="disableAllTableActions">
                            </sera-input-text>
                            <span *ngIf="col.isDisabled">{{ rowData[col.seraTableAction.value] }}</span>
                        </div>
                        <div *ngSwitchCase="'inputNumberWithFactor'">
                            <div
                                class="sera-table-input-multiple-rows"
                                *ngIf="!col.isDisabled">
                                <sera-input-number
                                    (inputNumberFocus)="handleInputNumberFocus(col)"
                                    (inputNumberBlur)="handleInputNumberBlur(rowData, col.seraTableAction, $event)"
                                    [ngModel]="rowData[col.seraTableAction.value]"
                                    (ngModelChange)="updateRowDataValue(rowData, col.seraTableAction, $event)"
                                    [isDisabled]="disableAllTableActions">
                                </sera-input-number>
                                <sera-input-number
                                    [ngModel]="rowData[col.seraTableAction.factor]"
                                    [readOnly]="true">
                                </sera-input-number>
                            </div>
                            <div
                                class="sera-table-input-multiple-rows"
                                *ngIf="col.isDisabled">
                                <span
                                    class="sera-table-label-with-factor"
                                    *ngIf="col.isDisabled"
                                    >{{ rowData[col.seraTableAction.value] | number : '1.0-1' }}</span
                                >
                                <span
                                    class="sera-table-label-with-factor"
                                    *ngIf="col.isDisabled"
                                    >{{ rowData[col.seraTableAction.factor] | number : '1.0-1' }}</span
                                >
                            </div>
                        </div>
                        <div *ngSwitchCase="'textLabelWithFactor'">
                            <div class="sera-table-input-multiple-rows">
                                <span class="sera-table-label-with-factor">{{ col.seraTableAction.value | translate }}</span>
                                <span class="sera-table-label-with-factor">{{ col.seraTableAction.factor | translate }}</span>
                            </div>
                        </div>
                        <div *ngSwitchCase="'disableInputNumberWithFactor'">
                            <div
                                *ngIf="!col.isDisabled"
                                class="sera-table-input-multiple-rows">
                                <sera-input-number
                                    [ngModel]="rowData[col.seraTableAction.value]"
                                    [readOnly]="true">
                                </sera-input-number>
                                <sera-input-number
                                    [ngModel]="rowData[col.seraTableAction.factor]"
                                    [readOnly]="true">
                                </sera-input-number>
                            </div>
                            <div
                                *ngIf="col.isDisabled"
                                class="sera-table-input-multiple-rows">
                                <span class="sera-table-label-with-factor">{{ rowData[col.seraTableAction.value] | number : '1.0-1' }}</span>
                                <span class="sera-table-label-with-factor">{{ rowData[col.seraTableAction.factor] | number : '1.0-1' }}</span>
                            </div>
                        </div>
                        <div *ngSwitchCase="'inputNumber'">
                            <sera-input-number
                                (inputNumberFocus)="handleInputNumberFocus(col)"
                                (inputNumberBlur)="handleInputNumberBlur(rowData, col.seraTableAction, $event)"
                                *ngIf="!col.isDisabled"
                                [ngModel]="rowData[col.seraTableAction.value]"
                                (ngModelChange)="updateRowDataValue(rowData, col.seraTableAction, $event)"
                                [isDisabled]="disableAllTableActions">
                            </sera-input-number>
                            <span
                                *ngIf="col.isDisabled"
                                class="sera-table-label-with-factor"
                                >{{ rowData[col.seraTableAction.value] | number : '1.0-1' }}</span
                            >
                        </div>
                        <div *ngSwitchCase="'disabledInputNumber'">
                            <sera-input-number
                                *ngIf="!col.isDisabled"
                                [ngModel]="rowData[col.seraTableAction.value]"
                                [readOnly]="true">
                            </sera-input-number>
                            <span *ngIf="col.isDisabled">{{ rowData[col.seraTableAction.value] | number : '1.0-1' }}</span>
                        </div>
                        <div *ngSwitchCase="'translate'">
                            <span>{{ rowData[col.field] | translate }}</span>
                        </div>
                        <div *ngSwitchCase="'dropDownWithFactor'">
                            <div
                                class="sera-table-input-multiple-rows"
                                *ngIf="!col.isDisabled">
                                <sera-dropdown
                                    [isFiltered]="col.seraDropDown.isFiltered"
                                    [label]="col.seraDropDown.label"
                                    [options]="col.seraDropDown.options"
                                    [showClear]="col.seraDropDown.showClear"
                                    [ngModel]="rowData[col.seraDropDown.value]"
                                    (selectionChanged)="updateRowDataValue(rowData, col.seraDropDown, $event, true)"
                                    [isDisabled]="disableAllTableActions">
                                </sera-dropdown>
                                <sera-input-number
                                    *ngIf="rowData[col.seraDropDown.factor]"
                                    [(ngModel)]="rowData[col.seraDropDown.factor]"
                                    [readOnly]="true">
                                </sera-input-number>
                            </div>
                            <div
                                *ngIf="col.isDisabled"
                                class="sera-table-input-multiple-rows">
                                <span
                                    class="sera-table-label-with-factor"
                                    [title]="getValueSelectedOfDropdown(rowData, col.seraDropDown)"
                                    *ngIf="col.isDisabled"
                                    >{{ getValueSelectedOfDropdown(rowData, col.seraDropDown) }}</span
                                >
                                <span class="sera-table-label-with-factor">{{ rowData[col.seraDropDown.factor] }}</span>
                            </div>
                        </div>
                        <div *ngSwitchCase="'dropDown'">
                            <div>
                                <sera-dropdown
                                    *ngIf="!col.isDisabled"
                                    [isFiltered]="col.seraDropDown.isFiltered"
                                    [label]="col.seraDropDown.label"
                                    [options]="col.seraDropDown.options"
                                    [showClear]="col.seraDropDown.showClear"
                                    [ngModel]="rowData[col.seraDropDown.value]"
                                    (selectionChanged)="updateRowDataValue(rowData, col.seraDropDown, $event, true)"
                                    [isDisabled]="disableAllTableActions">
                                </sera-dropdown>
                                <span
                                    [title]="getValueSelectedOfDropdown(rowData, col.seraDropDown)"
                                    *ngIf="col.isDisabled"
                                    >{{ getValueSelectedOfDropdown(rowData, col.seraDropDown) }}</span
                                >
                            </div>
                        </div>
                        <ng-container
                            *ngSwitchCase="'custom'"
                            [ngTemplateOutlet]="customSeraCell ? customSeraCell : null"
                            [ngTemplateOutletContext]="{
                                rowData: rowData
                            }"></ng-container>
                        <button
                            *ngSwitchCase="'link'"
                            type="button"
                            class="sera-table-link"
                            title="{{ rowData[col.field] }}"
                            (click)="col.openLinkFunction?.(rowData)">
                            {{ rowData[col.field] }}
                        </button>
                        <div *ngSwitchCase="'buttons'">
                            <div [ngClass]="{ 'button-col': true, 'button-col-gap': col.gap }">
                                <ng-container *ngFor="let button of col.seraButtons | filterButtonBasedOnDisplayMode : isEditMode : rowData">
                                    <sera-toggle-button
                                        *ngIf="(button.showButton ? button.showButton(rowData) : true) && button.type === 'toggleButton'"
                                        [onLabel]="button.onLabel!"
                                        [offLabel]="button.offLabel!"
                                        [onIcon]="button.onIcon!"
                                        [offIcon]="button.offIcon!"
                                        [ngModel]="button.isToggled!(rowData)"
                                        (stateChanged)="button.action({ rowData: rowData, rowIndex: rowIndex, event: $event })"
                                        [class]="button.buttonClass!"
                                        [disabled]="(button.isDisabled ? button.isDisabled(rowData) : false) || disableAllTableActions">
                                    </sera-toggle-button>
                                    <ds-button
                                        *ngIf="(button.showButton ? button.showButton(rowData) : true) && button.type === 'iconButton'"
                                        [disabled]="disableAllTableActions"
                                        (click)="button.action({ rowData: rowData, rowIndex: rowIndex })"
                                        [icon]="button.defaultIconClass!"
                                        [pTooltip]="button.label! | translate"
                                        tooltipPosition="top"
                                        [variant]="button.variant ?? 'ghost'"
                                        size="sm">
                                    </ds-button>
                                    <ds-button
                                        *ngIf="(button.showButton ? button.showButton(rowData) : true) && button.type === 'menuButton'"
                                        [ds-menu-trigger-for]="menu"
                                        [variant]="button.variant ?? 'ghost'"
                                        [disclosureIcon]="'more_vertical'"
                                        [size]="'sm'" />
                                    <ds-menu #menu>
                                        <ng-container *ngFor="let item of button.seraButtons">
                                            <ds-list-item
                                                *ngIf="item.showButton ? item.showButton(rowData) : true"
                                                (click)="item.action(rowData)"
                                                (keydown)="item.action(rowData)">
                                                <div class="menu-item">
                                                    <ds-icon
                                                        *ngIf="item?.defaultIconClass"
                                                        [icon]="item?.defaultIconClass!"
                                                        [size]="'sm'" />
                                                    {{ item?.label! | translate }}
                                                </div>
                                            </ds-list-item>
                                        </ng-container>
                                    </ds-menu>
                                </ng-container>
                            </div>
                        </div>
                        <div
                            *ngSwitchCase="'trafficLight'"
                            [ngClass]="col.styleTextCell">
                            <sera-ri-value
                                [label]="'PAGE.ANALYSIS.CRITERION_RZ.LBL' | translate"
                                [value]="rowData.rzValue"
                                [color]="rowData.color"
                                [withLabel]="col.withLabel ?? true" />
                        </div>
                        <div
                            *ngSwitchCase="'shiValue'"
                            [ngClass]="col.styleTextCell">
                            <ds-tag
                                [title]="(rowData[col.field] | number : '1.1-1') ?? '0'"
                                class="sera-table-td-shi_value"
                                [size]="col.customParams?.size ?? 'md'"
                                [tone]="getToneForSHIValue(rowData['color'])">
                                {{ (rowData[col.field] | number : '1.1-1') ?? 0 }}
                            </ds-tag>
                        </div>
                        <div
                            *ngSwitchCase="'criterionValue'"
                            [ngClass]="col.styleTextCell">
                            <ds-tag
                                [title]="(rowData[col.field] | number : '1.0-0') ?? '0'"
                                class="sera-table-td-shi_value"
                                [size]="col.customParams?.size ?? 'md'"
                                [tone]="getToneForSHIValue(rowData[col.field + 'Color'])">
                                {{ (rowData[col.field] | number : '1.0-0') ?? 0 }}
                            </ds-tag>
                        </div>
                        <div
                            *ngSwitchCase="'colorField'"
                            [ngClass]="col.styleTextCell">
                            <ds-tag
                                class="sera-table-td-maternity"
                                [size]="col.customParams?.size ?? 'md'"
                                [tone]="getToneForSHIValue(rowData[col.field])"
                                >&nbsp;
                            </ds-tag>
                        </div>
                        <div *ngSwitchCase="'enum'">
                            <span
                                [title]="(col.customParams?.capitalize ? ((col.enum?.[rowData[col.field]] | translate) | titlecase) : (col.enum?.[rowData[col.field]] | translate)) ?? '-'">
                                {{
                                    (
                                        col.customParams?.capitalize
                                            ? ((col.enum?.[rowData[col.field]] | translate) | titlecase)
                                            : (col.enum?.[rowData[col.field]] | translate)
                                    ) ?? '-'
                                }}
                            </span>
                        </div>
                        <div *ngSwitchCase="'date'">
                            <span [title]="(rowData[col.field] | date : col.customParams?.format ?? 'dd/MM/yyyy HH:mm') ?? '-'">{{
                                (rowData[col.field] | date : col.customParams?.format ?? 'dd/MM/yyyy HH:mm') ?? '-'
                            }}</span>
                        </div>
                        <div *ngSwitchCase="'array'">
                            <span [title]="rowData[col.field]?.join(', ')">{{ rowData[col.field]?.join(', ') }}</span>
                        </div>
                        <div
                            class="sera-table-td-span_icon_text"
                            *ngSwitchCase="'spanIconAndText'">
                            <span [class]="rowData[col.class]"></span>
                            <span>{{ rowData[col.field] }}</span>
                        </div>
                        <div *ngSwitchDefault>
                            <span [title]="(col.customParams?.capitalize ? (rowData[col.field] | titlecase) : rowData[col.field]) || '-'">
                                {{ (col.customParams?.capitalize ? (rowData[col.field] | titlecase) : rowData[col.field]) || '-' }}
                            </span>
                        </div>
                    </ng-container>
                </div>
            </td>
            <td *ngIf="dragAndDropEnabled">
                <span
                    class="ci ci-drag_indicator sera-table-draggable-cell"
                    pReorderableRowHandle></span>
            </td>
        </tr>
    </ng-template>
    <ng-template
        #emptymessage
        let-columns>
        <tr class="sera-table-empty__state__container">
            <td [attr.colspan]="columns.length + (isSelection ? 1 : 0) + (dragAndDropEnabled ? 1 : 0)">
                <div
                    class="sera-table-empty__state__container__content"
                    [style.height]="emptyStateHeightPx ? emptyStateHeightPx + 'px' : 'auto'">
                    @if (hasSearched) {
                    <sera-image
                        [imageItem]="noResultsImage"
                        [noStyle]="true"
                        class="sera-table-empty__state__container__content__image">
                    </sera-image>
                    <div class="sera-table-empty__state__container__wrapper">
                        <p class="sera-table-empty__state__container__content__title_bold-text">{{ noResultsMessage | translate }}</p>
                        <p class="text-label sera-table-empty__state__container__content__sub-message">{{ noResultsSubMessage | translate }}</p>
                    </div>
                    } @else {
                    <sera-image
                        [imageItem]="emptyStateImage"
                        [noStyle]="true"
                        class="sera-table-empty__state__container__content__image">
                    </sera-image>
                    <p class="sera-table-empty__state__container__content__title_bold-text">{{ emptyStateMessage | translate }}</p>
                    }
                    <ds-button
                        *ngIf="isEmptyStateButtonVisible"
                        [disabled]="isEmptyStateButtonDisabled"
                        (click)="emptyStateButton!.action()"
                        tooltipPosition="top"
                        [variant]="'primary'"
                        [icon]="'add'"
                        size="md"
                        >{{ emptyStateButton!.label | translate }}
                    </ds-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
